import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllPrograms,
  onCreateProgram,
  onDeleteProgram,
  onGetProgram,
  onUpdateProgram,
} from '../../../app/modules/system-definitions/components/programs/core/_requests'
import {
  onGetDegrees,
  onGetDepartmentsByFacultyId,
  onGetFaculties,
  onGetProgramTypesByDegreeId,
  onGetSubDepartmentsByDepartmentId,
  onGetUniversities,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface ProgramState {
  programs: any
  program: any
  faculties: any
  departments: any
  universities: any
  degrees: any
  programTypes: any
  isLoading: boolean
  subDepartments: any
}
const initialState = {
  programs: [],
  faculties: [],
  departments: [],
  universities: [],
  subDepartments: [],
  degrees: [],
  programTypes: [],
  program: null,
  isLoading: true,
} as ProgramState

export const fetchUniversities = createAsyncThunk('program/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk('program/fetchFaculties', async (param: any) => {
  const data: any = await onGetFaculties()
  return data.data.result
})

export const fetchDepartments = createAsyncThunk('program/fetchDepartments', async (param: any) => {
  const data: any = await onGetDepartmentsByFacultyId(param)
  return data.data.result
})

export const fetchSubDepartments = createAsyncThunk(
  'program/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetSubDepartmentsByDepartmentId(param)
    return data.data.result
  }
)

export const fetchDegrees = createAsyncThunk('program/fetchDegrees', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})

export const fetchProgramTypes = createAsyncThunk(
  'program/fetchProgramTypes',
  async (param: any) => {
    const data: any = await onGetProgramTypesByDegreeId(param)
    return data.data.result
  }
)

export const fetchPrograms = createAsyncThunk('program/fetchPrograms', async (param: any) => {
  const data: any = await onGetPagedAllPrograms(param)
  return data.data.result
})

export const fetchProgram = createAsyncThunk('program/fetchProgram', async (param: any) => {
  const data: any = await onGetProgram(param)
  return data.data.result
})

export const updateProgram = createAsyncThunk('program/updateProgram', async (param: any) => {
  const data: any = await onUpdateProgram(param)
  return data.data
})

export const createProgram = createAsyncThunk('program/createProgram', async (param: any) => {
  const data: any = await onCreateProgram(param)
  return data.data
})

export const deleteProgram = createAsyncThunk('program/deleteProgram', async (param: any) => {
  const data: any = await onDeleteProgram(param)
  return data.data
})

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    clearPrograms: (state) => {
      state.programs = []
    },
    clearProgram: (state) => {
      state.program = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPrograms.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchPrograms.fulfilled, (state: any, action) => {
      state.programs = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchPrograms.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchProgram.fulfilled, (state: any, action) => {
      state.program = action.payload
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload.items
    })
    builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
      state.subDepartments = action.payload.items
    })
    builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
      state.degrees = action.payload.items
    })
    builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
      state.programTypes = action.payload.items
    })
  },
})

export const {clearPrograms, clearProgram, activateLoading} = programSlice.actions

export default programSlice.reducer
